import { Value } from 'src_common/common/mobx-utils/Value';
import { SportModelType } from 'src_common/common/websocket2/modelsApi/Sport';

export class SportModel {
    private readonly model: Value<SportModelType>;

    public constructor(model: Value<SportModelType>) {
        this.model = model;
    }

    public getData(): SportModelType {
        return this.model.getValue();
    }

    public get id(): string {
        return this.getData().id;
    }

    public get displayOrder(): number {
        return this.getData().displayOrder;
    }

    public get name(): string {
        return this.getData().name;
    }
}
